import AbstractNode from './AbstractNode';
import {TextSelection} from 'prosemirror-state';
import {findColumn, goToNextColumn, isInGrid} from '../helper/nodeSelection';

export default class Grid extends AbstractNode {
    get name() {
        return "grid";
    }

    get schema() {
        return {
            content: "grid_column+",
            group: "block",
            parseDOM: [{
                tag: 'div.ui.grid'
            }],
            toDOM: () => ["div", {'class': 'ui compact stackable grid'}, 0]
        }
    }

    toMarkdown(state, node) {
        state.flushClose(2);
        state.write('<div class="ui compact stackable grid">');
        state.ensureNewLine();
        state.renderContent(node);
        state.write('</div>');
        state.ensureNewLine();
        state.closeBlock(node);
    }

    get parseMarkdown() {
        return {
            block: "grid"
        }
    }

    keys({type}) {
      return {
        Tab: (state, dispatch) => {
          if (!isInGrid(state)) {
            return false;
          }

          if (!goToNextColumn(1)(state, dispatch)) {
            const column = findColumn(state);
            const pos = column.pos + column.node.content.size;
            const tr = state.tr.insert(
                pos,
                state.schema.nodes.grid_column.createAndFill({width: 8})
            ).scrollIntoView();
            const resolvedPos = tr.doc.resolve(pos + 1);
            dispatch(tr.setSelection(TextSelection.near(resolvedPos)));
          }

          return true;
        },
        "Shift-Tab": goToNextColumn(-1)
      };
    }

    commands({schema}) {
        return {
            createGrid: () => view => {
                const offset = view.state.tr.selection.anchor + 1;
                const tr = view.state.tr.replaceSelectionWith(schema.nodes.grid.createAndFill({}, [
                  schema.nodes.grid_column.createAndFill({width: 8}),
                  schema.nodes.grid_column.createAndFill({width: 8})
                ])).scrollIntoView();
                const resolvedPos = tr.doc.resolve(offset);
                view.dispatch(tr.setSelection(TextSelection.near(resolvedPos)));
            }
        };
    }
}